module.exports = __webpack_public_path__ + "img/passport-wrong-finger.620fc326.png";